import { createFileRoute } from '@tanstack/react-router'
import { WorkspacesPage } from '@/features/workspaces/WorkspacesPage'

/**
 * Story E02.06 — `/workspace` route. The `_authenticated` parent already
 * runs the auth-guard (`bootstrapAuth`), so this route only mounts the
 * page component.
 */
export const Route = createFileRoute('/_authenticated/workspace')({
  component: WorkspacesPage,
})
